import { Alert, Avatar, Button, Card, Col, DatePicker, Divider, Image, Input, Modal, Row, Select, Spin, Table, Tag, Timeline, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { dateFormat } from '../../Utils/formatDate';
import heic2any from "heic2any";
import './ApprovalToolbar.css';

const { Option } = Select;
function ApprovalAttendance({ embedded = false }) {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detailData, setDetailData] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [convertedImage, setConvertedImage] = useState("");
    const [bulkModalVisible, setBulkModalVisible] = useState(false);
    const [bulkStatus, setBulkStatus] = useState('');
    const [bulkReason, setBulkReason] = useState('');
    const [bulkLoading, setBulkLoading] = useState(false);
    const [targetId, setTargetId] = useState(null); // untuk change status di detail

    const [statusTimeFilter, setStatusTimeFilter] = useState('');
    const [dateRange, setDateRange] = useState([]);
    const [sorter, setSorter] = useState({ field: 'created_at', order: 'descend' });

    useEffect(() => {
        const convertHeic = async () => {
            if (!detailData?.image) return;

            try {
                const imageUrl = detailData.image;

                if (imageUrl.toLowerCase().endsWith(".heic")) {
                    const response = await fetch(imageUrl, { mode: "cors" });
                    const blob = await response.blob();

                    const converted = await heic2any({
                        blob,
                        toType: "image/jpeg",
                        quality: 0.9,
                    });

                    setConvertedImage(URL.createObjectURL(converted));
                } else {
                    setConvertedImage(imageUrl);
                }
            } catch (error) {
                console.error("Gagal konversi HEIC:", error);
                setConvertedImage(detailData.image);
            }
        };

        convertHeic();
    }, [detailData]);

    const titlePage = 'Attendance Approval Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: "image",
            render: (text, record) => {
                if (record.image !== null && record.image !== '')
                    return <Image src={record.image} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '8px' }} />;
                else
                    return 'No Image';
            }
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            key: "users_code",
            sorter: true,
            render: (text, record) => record.users?.users_code
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true,
            render: (text, record) => record.users?.name
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: "date",
            sorter: true,
            render: (text, record) => (<p>{moment(record.date).format('DD-MM-YYYY')}</p>)
        },
        {
            title: 'Time',
            dataIndex: 'time',
            key: "time",
            sorter: true,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                switch (record.status) {
                    case 'checkin':
                        return <Tag color='blue-inverse'>Clock In</Tag>
                    case 'checkout':
                        return <Tag color='pink-inverse'>Clock Out</Tag>
                }
            }
        },
        {
            title: 'Approval Status',
            dataIndex: 'status_submission',
            key: "status_submission",
            sorter: true,
            render: (text, record) => {
                switch (record.status_submission) {
                    case 'Approved':
                        return <Tag color='green'>{record.status_submission}</Tag>
                    case 'Rejected':
                        return <Tag color='red'>{record.status_submission}</Tag>
                    default:
                        return <Tag color='yellow'>{record.status_submission}</Tag>
                }
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Button type="default" onClick={() => showDetailModal(record)}>
                    <b>Detail</b>
                </Button>
            )
        }

    ];

    const showDetailModal = (data) => {
        getApi('GET', '/attendance/' + data.attendance_id, 'detail');
    };

    useEffect(() => {
        const statusQuery = statusFilter
            ? `&status=${encodeURIComponent(statusFilter)}`
            : '';

        const statusTimeQuery = statusTimeFilter
            ? `&statusTime=${encodeURIComponent(statusTimeFilter)}`
            : '';

        const searchQuery = search
            ? `&search=${encodeURIComponent(search)}`
            : '';
        const dateQuery = dateRange?.length === 2
            ? `&dateStart=${dateRange[0].format('YYYY-MM-DD')}&dateEnd=${dateRange[1].format('YYYY-MM-DD')}`
            : '';
        const sortField = sorter?.field || 'created_at';
        const sortOrder = sorter?.order === 'ascend' ? 'asc' : 'desc';
        const sortQuery = `&sortBy=${encodeURIComponent(sortField)}&order=${sortOrder}`;

        getApi(
            'GET',
            `/attendance?isDelegation=true&isAttendance=false${searchQuery}${statusQuery}${statusTimeQuery}${dateQuery}${sortQuery}&page=${pagination.current}&limit=${pagination.pageSize}`,
            'attendance'
        );
    }, [
        pagination.current,
        pagination.pageSize,
        search,
        statusFilter,
        statusTimeFilter,
        dateRange,
        sorter,
        isAlert,
    ]);

    const getApi = async (method, url, type) => {
        setLoading(true);

        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        };

        try {
            const res = await apiCall(dataReq);

            if (res.status !== 'success') {
                modalError(res.message || 'Failed to retrieve data');
                return;
            }

            if (type === 'detail') {
                setDetailData(res.data);
                setIsModalVisible(true);
                return;
            }

            setData(res.data?.data || []);

            setPagination((previous) => ({
                ...previous,
                total: res.data?.total_data || 0,
            }));
        } catch (error) {
            console.error('Attendance API error:', error);
            modalError(error?.message || 'Failed to retrieve data');
        } finally {
            setLoading(false);
        }
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setTextAlert(res.message);
                setIsAlert(true);
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    const handleTableChange = (newPagination, _filters, newSorter) => {
        setPagination((previous) => {
            const pageSizeChanged = previous.pageSize !== newPagination.pageSize;
            return {
                ...previous,
                current: pageSizeChanged ? 1 : newPagination.current,
                pageSize: newPagination.pageSize,
            };
        });
        if (newSorter?.field || newSorter?.columnKey) {
            setSorter({ field: newSorter.field || newSorter.columnKey, order: newSorter.order || 'descend' });
        }
    };

    const searchData = (value) => {
        setSearch(value);

        setPagination((previous) => ({
            ...previous,
            current: 1,
        }));
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
        getCheckboxProps: () => ({ disabled: false }),
    };

    return (
        <div>
            {!embedded && <Helmet><title>{titlePage}</title></Helmet>}
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            {!embedded && <h3>Attendance Approval Data</h3>}
<div className="approval-toolbar">
    <div className="approval-toolbar__search">
        <Search
            placeholder="Search employee or description"
            allowClear
            enterButton="Search"
            size="middle"
            onSearch={searchData}
        />
    </div>

    <div className="approval-toolbar__date">
        <DatePicker.RangePicker
            style={{ width: '100%' }}
            value={dateRange}
            onChange={(value) => {
                setDateRange(value || []);
                setPagination((previous) => ({ ...previous, current: 1 }));
            }}
            format="DD-MM-YYYY"
            placeholder={['Start date', 'End date']}
        />
    </div>

    <div className="approval-toolbar__filter">
        <Select
            placeholder="Approval Status"
            allowClear
            style={{ width: '100%' }}
            value={statusFilter || undefined}
            onChange={(value) => {
                setStatusFilter(value || '');
                setPagination((previous) => ({ ...previous, current: 1 }));
            }}
        >
            <Option value="Process">Process</Option>
            <Option value="Approved">Approved</Option>
            <Option value="Rejected">Rejected</Option>
        </Select>
    </div>

    <div className="approval-toolbar__filter">
        <Select
            placeholder="Attendance Type"
            allowClear
            style={{ width: '100%' }}
            value={statusTimeFilter || undefined}
            onChange={(value) => {
                setStatusTimeFilter(value || '');
                setPagination((previous) => ({ ...previous, current: 1 }));
            }}
        >
            <Option value="checkin">Clock In</Option>
            <Option value="checkout">Clock Out</Option>
        </Select>
    </div>

    <div className="approval-toolbar__action">
        <Button
            type="primary"
            block
            onClick={() => setBulkModalVisible(true)}
            disabled={selectedRowKeys.length === 0}
        >
            Action Bulk ({selectedRowKeys.length})
        </Button>
    </div>
</div>
            <Table
                rowKey={(record) => record.attendance_id}
                rowSelection={rowSelection}
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} dari ${total} data`,
                }}
                loading={loading}
                onChange={handleTableChange}
            />


            <Modal
                title="Attendance Submission Detail"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={900}
            >
                {loading ? (
                    <Spin tip="Loading..." style={{ display: "block", textAlign: "center" }} />
                ) : (
                    detailData && (
                        <Card>
                            <Typography.Title level={5}>Attendance Information</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Employee Name:</Typography.Text>
                                    <Typography.Paragraph>{detailData.users?.name || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Attendance Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.status === 'checkin' ? 'Check In' : 'Check Out'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Date:</Typography.Text>
                                    <Typography.Paragraph>{new Date(detailData.date).toLocaleDateString()}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Time:</Typography.Text>
                                    <Typography.Paragraph>{detailData.time}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Late Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.is_late ? 'Late' : 'On Time'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Submitted By:</Typography.Text>
                                    <Typography.Paragraph>{detailData.users?.name || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={24}>
                                    <Typography.Text strong>Note:</Typography.Text>
                                    <Typography.Paragraph>{detailData.desc || '-'}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Shift</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Shift Name:</Typography.Text>
                                    <Typography.Paragraph>{detailData.shift?.name || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={6}>
                                    <Typography.Text strong>Start:</Typography.Text>
                                    <Typography.Paragraph>{detailData.shift?.time_in}</Typography.Paragraph>
                                </Col>
                                <Col span={6}>
                                    <Typography.Text strong>End:</Typography.Text>
                                    <Typography.Paragraph>{detailData.shift?.time_out}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Location & Evidence</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <div style={{ height: '250px', width: '100%', borderRadius: 10, overflow: 'hidden' }}>
                                        <MapContainer
                                            center={[parseFloat(detailData.latitude), parseFloat(detailData.longitude)]}
                                            zoom={16}
                                            style={{ height: '100%', width: '100%' }}
                                            scrollWheelZoom={false}
                                        >
                                            <TileLayer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                attribution="&copy; OpenStreetMap contributors"
                                            />
                                            <Marker position={[parseFloat(detailData.latitude), parseFloat(detailData.longitude)]} />
                                        </MapContainer>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <Image
                                        alt="Attendance Evidence"
                                        src={convertedImage || detailData.image}
                                        width={250}
                                        height={250}
                                        style={{
                                            objectFit: "contain",
                                            borderRadius: "10px",
                                            border: '1px solid #F2F2F2'
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Approval History</Typography.Title>
                            <Timeline mode="left" style={{ marginTop: 20 }}>
                                {/* Requested */}
                                <Timeline.Item color="blue">
                                    <Row gutter={8} align="middle">
                                        <Col>
                                            <Avatar src={detailData.users?.image} />
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>{detailData.users?.name || "-"}</Typography.Text><br />
                                            <Tag color="blue">Process</Tag><br />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                {dateFormat(detailData.created_at) || "-"}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Timeline.Item>

                                {/* Approval Timeline */}
                                {detailData.attendance_approval.map((approval) => (
                                    <Timeline.Item
                                        key={approval.attendance_approval_id}
                                        color={
                                            approval.status_approval_id === 2
                                                ? "green"
                                                : approval.status_approval_id === 3
                                                    ? "red"
                                                    : "yellow"
                                        }
                                    >
                                        <Row gutter={8} align="middle">
                                            <Col>
                                                <Avatar src={approval.user?.image} />
                                            </Col>
                                            <Col>
                                                <Typography.Text strong>{approval.user?.name || "-"}</Typography.Text><br />
                                                {detailData.users.users_id === approval.user?.users_id ? (
                                                    <Tag color="red">Dibatalkan</Tag>
                                                ) : (
                                                    <Tag
                                                        color={
                                                            approval.status_approval_id === 2
                                                                ? "green"
                                                                : approval.status_approval_id === 3
                                                                    ? "red"
                                                                    : "yellow"
                                                        }
                                                    >
                                                        {approval.status_approval?.status}
                                                    </Tag>
                                                )}
                                                <br />
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {dateFormat(approval.created_at) || "-"}
                                                </Typography.Text><br />
                                                {approval.reason && (
                                                    <Typography.Text italic style={{ fontSize: 12 }}>
                                                        Reason: {approval.reason}
                                                    </Typography.Text>
                                                )}
                                            </Col>
                                        </Row>
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                            {detailData && (
                                <div style={{ marginTop: 20, textAlign: 'right' }}><Button
                                    onClick={() => {
                                        setTargetId(detailData.attendance_id);
                                        setBulkStatus('');
                                        setBulkReason('');

                                        // pastikan detail modal stabil dulu, baru buka modal baru
                                        setTimeout(() => {
                                            setBulkModalVisible(true);
                                        }, 150);
                                    }}
                                >
                                    Change Status
                                </Button>
                                </div>
                            )}
                        </Card>
                    )
                )}
            </Modal>

            <Modal
                title="Approval Action"
                open={bulkModalVisible}
                zIndex={2000} // pastikan di atas modal detail
                getContainer={false}
                onCancel={() => {
                    setBulkModalVisible(false);
                    setTargetId(null);
                    setBulkStatus('');
                    setBulkReason('');
                }}
                onOk={async () => {
                    if (!bulkStatus) {
                        modalError('Please select approval status');
                        return;
                    }

                    const payload = {
                        status_approval_id: bulkStatus === 'Approved' ? 2 : 3,
                        reason: bulkReason || '',
                    };

                    setBulkLoading(true);
                    try {
                        if (targetId) {
                            await postApi('PUT', `/attendanceapprovalfinal/${targetId}`, payload);
                        } else {
                            await postApi('PUT', '/attendanceapprovalfinalbulk', {
                                ids: selectedRowKeys,
                                ...payload,
                            });
                        }
                    } finally {
                        setBulkLoading(false);
                        setBulkModalVisible(false);
                        setIsModalVisible(false)
                        setTargetId(null);
                        setBulkStatus('');
                        setBulkReason('');
                    }
                }}
                okText={bulkLoading ? 'Processing...' : 'Submit'}
                okButtonProps={{ loading: bulkLoading }}
            >
                <p>
                    {targetId
                        ? 'Set approval for this attendance submission'
                        : `${selectedRowKeys.length} item(s) selected`}
                </p>
                <Select
                    placeholder="Select Status"
                    style={{ width: '100%', marginBottom: 12 }}
                    onChange={setBulkStatus}
                    value={bulkStatus}
                >
                    <Option value="Approved">Approved</Option>
                    <Option value="Rejected">Rejected</Option>
                </Select>
                <Input.TextArea
                    placeholder="Reason (optional)"
                    rows={3}
                    value={bulkReason}
                    onChange={(e) => setBulkReason(e.target.value)}
                />
            </Modal>

        </div>
    );
}

export default ApprovalAttendance;
